var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 13,
    viewBox: "0 0 28 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.5L18 0.726499L18 12.2735L28 6.5ZM-8.74228e-08 7.5L19 7.5L19 5.5L8.74228e-08 5.5L-8.74228e-08 7.5Z",
    fill: "#D2EDD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForm);
export default __webpack_public_path__ + "static/media/arrow_form.ee53908c78d79618706b1a71758de81d.svg";
export { ForwardRef as ReactComponent };